<script setup lang="ts">
import type { DialogDismissReason, DialogInstance, DialogService } from '.';
import { computed, inject, nextTick, ref, watch } from 'vue';
import SphButton from '@/components/base/button';
import SphDialog from '@/components/base/dialog/internal/DialogGeneric.vue';
import splitLines from '@/utils/strings/splitLines';

defineOptions({
    compatConfig: { MODE: 3 },
})

const dialog = inject<DialogService>('dialog')!;

const current = ref<DialogInstance | null>(null);

watch(() => dialog.dialogs[0], (next) => {
    if (next && !current.value) {
        current.value = next;
    }
});

const messageLines = computed(() => splitLines(current.value?.options.message || ''));

function onClose() {
    current.value?.close();
    current.value = null;
    nextTick(() => {
        if (dialog.dialogs[0]) {
            current.value = dialog.dialogs[0];
        }
    });
}
</script>

<template>
    <SphDialog
        v-if="current"
        :key="current.id"
        :title="current.options?.title"
        :persistent="current.options?.persistent"
        :no-backdrop-dismiss="current.options?.noBackdropDismiss"
        :no-escape-dismiss="current.options?.noEscapeDismiss"
        :no-close-button="current.options?.noCloseButton"
        :state="current.isOpen"
        @dismiss="(reason: string) => current?.triggerDismiss(reason as DialogDismissReason)"
        @close="onClose"
    >
        <p
            v-for="(line, index) in messageLines"
            :key="index"
            class="block mb-4 last:mb-0"
        >
            {{ line }}
        </p>

        <template
            v-if="current?.options?.buttons?.length"
            #footer
        >
            <SphButton
                v-for="button in current?.options?.buttons"
                :key="button.label"
                :variant="button.variant"
                :label="button.label"
                @click="current!.triggerButton(button.value)"
            />
        </template>
    </SphDialog>
</template>
